/* tslint:disable */
/* eslint-disable */
/**
 * User Service API
 * API for user service with authentication and session management
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ben@xp-lab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ActivityLogEntry
 */
export interface ActivityLogEntry {
    /**
     * Unique identifier for the activity log entry
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'id': string;
    /**
     * ID of the user who performed the action
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'userId'?: string;
    /**
     * Email of the user who performed the action
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'userEmail'?: string;
    /**
     * Type of action performed
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'action': string;
    /**
     * Service that performed the action
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'service'?: string;
    /**
     * When the action occurred
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'timestamp': string;
    /**
     * Additional details about the action
     * @type {string}
     * @memberof ActivityLogEntry
     */
    'details'?: string;
}
/**
 * 
 * @export
 * @interface AdminChallengesOverTimePoint
 */
export interface AdminChallengesOverTimePoint {
    /**
     * Start of the time bucket (day or week) in UTC
     * @type {string}
     * @memberof AdminChallengesOverTimePoint
     */
    'bucketStart': string;
    /**
     * Number of challenges started in this bucket
     * @type {number}
     * @memberof AdminChallengesOverTimePoint
     */
    'startedCount': number;
    /**
     * Number of challenges submitted in this bucket
     * @type {number}
     * @memberof AdminChallengesOverTimePoint
     */
    'submittedCount': number;
}
/**
 * 
 * @export
 * @interface AdminDailyCountPoint
 */
export interface AdminDailyCountPoint {
    /**
     * The UTC date for this data point
     * @type {string}
     * @memberof AdminDailyCountPoint
     */
    'date': string;
    /**
     * Count value for the given date
     * @type {number}
     * @memberof AdminDailyCountPoint
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AdminDashboardResponse
 */
export interface AdminDashboardResponse {
    /**
     * Total number of registered users
     * @type {number}
     * @memberof AdminDashboardResponse
     */
    'totalUsers': number;
    /**
     * Total number of tasks in the system
     * @type {number}
     * @memberof AdminDashboardResponse
     */
    'totalTasks': number;
    /**
     * Number of completed challenges
     * @type {number}
     * @memberof AdminDashboardResponse
     */
    'completedChallenges': number;
    /**
     * Recent activity log entries
     * @type {Array<ActivityLogEntry>}
     * @memberof AdminDashboardResponse
     */
    'activityLog': Array<ActivityLogEntry>;
    /**
     * Recent admin news log entries
     * @type {Array<ActivityLogEntry>}
     * @memberof AdminDashboardResponse
     */
    'adminNewsLog': Array<ActivityLogEntry>;
}
/**
 * 
 * @export
 * @interface AdminDeleteUserRequest
 */
export interface AdminDeleteUserRequest {
    /**
     * If true, returns resources that would be deleted without actually deleting them
     * @type {boolean}
     * @memberof AdminDeleteUserRequest
     */
    'dryRun': boolean;
}
/**
 * 
 * @export
 * @interface AdminDeleteUserResponse
 */
export interface AdminDeleteUserResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminDeleteUserResponse
     */
    'dryRun': boolean;
    /**
     * 
     * @type {AdminDeleteUserResponseUser}
     * @memberof AdminDeleteUserResponse
     */
    'user': AdminDeleteUserResponseUser;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof AdminDeleteUserResponse
     */
    'challenges': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof AdminDeleteUserResponse
     */
    'assignments': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof AdminDeleteUserResponse
     */
    'cohorts': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof AdminDeleteUserResponse
     */
    'persons': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof AdminDeleteUserResponse
     */
    'invitations': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {AdminDeleteUserResponseSessions}
     * @memberof AdminDeleteUserResponse
     */
    'sessions': AdminDeleteUserResponseSessions;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof AdminDeleteUserResponse
     */
    'activityEvents': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {AdminDeleteUserResponseDeletedCounts}
     * @memberof AdminDeleteUserResponse
     */
    'deletedCounts'?: AdminDeleteUserResponseDeletedCounts;
}
/**
 * 
 * @export
 * @interface AdminDeleteUserResponseDeletedCounts
 */
export interface AdminDeleteUserResponseDeletedCounts {
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteUserResponseDeletedCounts
     */
    'challenges'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteUserResponseDeletedCounts
     */
    'assignments'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteUserResponseDeletedCounts
     */
    'cohorts'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteUserResponseDeletedCounts
     */
    'persons'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteUserResponseDeletedCounts
     */
    'invitations'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteUserResponseDeletedCounts
     */
    'sessions'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteUserResponseDeletedCounts
     */
    'activityEvents'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteUserResponseDeletedCounts
     */
    'user'?: number;
}
/**
 * 
 * @export
 * @interface AdminDeleteUserResponseSessions
 */
export interface AdminDeleteUserResponseSessions {
    /**
     * 
     * @type {number}
     * @memberof AdminDeleteUserResponseSessions
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AdminDeleteUserResponseUser
 */
export interface AdminDeleteUserResponseUser {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof AdminDeleteUserResponseUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeleteUserResponseUser
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface AdminStatisticsResponse
 */
export interface AdminStatisticsResponse {
    /**
     * Daily user signups over time
     * @type {Array<AdminDailyCountPoint>}
     * @memberof AdminStatisticsResponse
     */
    'userSignupsOverTime': Array<AdminDailyCountPoint>;
    /**
     * Daily challenges started and submitted over time
     * @type {Array<AdminChallengesOverTimePoint>}
     * @memberof AdminStatisticsResponse
     */
    'challengesOverTimeDaily': Array<AdminChallengesOverTimePoint>;
    /**
     * Weekly challenges started and submitted over time (aggregated by week)
     * @type {Array<AdminChallengesOverTimePoint>}
     * @memberof AdminStatisticsResponse
     */
    'challengesOverTimeWeekly': Array<AdminChallengesOverTimePoint>;
    /**
     * Per-task overview including challenge count and average grade
     * @type {Array<AdminTaskOverviewEntry>}
     * @memberof AdminStatisticsResponse
     */
    'tasksOverview': Array<AdminTaskOverviewEntry>;
}
/**
 * 
 * @export
 * @interface AdminTaskOverviewEntry
 */
export interface AdminTaskOverviewEntry {
    /**
     * Unique task identifier
     * @type {string}
     * @memberof AdminTaskOverviewEntry
     */
    'taskId': string;
    /**
     * Human-readable task name
     * @type {string}
     * @memberof AdminTaskOverviewEntry
     */
    'taskName': string;
    /**
     * Number of challenges for this task
     * @type {number}
     * @memberof AdminTaskOverviewEntry
     */
    'challengesCount': number;
    /**
     * Average grade for this task across all completed challenges (0-100)
     * @type {number}
     * @memberof AdminTaskOverviewEntry
     */
    'averageGrade': number;
}
/**
 * 
 * @export
 * @interface AdminUserAssignment
 */
export interface AdminUserAssignment {
    /**
     * 
     * @type {string}
     * @memberof AdminUserAssignment
     */
    'assignmentId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserAssignment
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserAssignment
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserAssignment
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserAssignment
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserAssignment
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserAssignment
     */
    'dueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserAssignment
     */
    'overdueDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminUserAssignment
     */
    'submissions'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserAssignment
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface AdminUserChallenge
 */
export interface AdminUserChallenge {
    /**
     * 
     * @type {string}
     * @memberof AdminUserChallenge
     */
    'challengeId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserChallenge
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserChallenge
     */
    'taskName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserChallenge
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserChallenge
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserChallenge
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserChallenge
     */
    'endTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminUserChallenge
     */
    'feedbackGrade'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserChallenge
     */
    'feedbackStatus'?: string;
}
/**
 * 
 * @export
 * @interface AdminUserDetailsResponse
 */
export interface AdminUserDetailsResponse {
    /**
     * 
     * @type {User}
     * @memberof AdminUserDetailsResponse
     */
    'user': User;
    /**
     * 
     * @type {Array<AdminUserChallenge>}
     * @memberof AdminUserDetailsResponse
     */
    'challenges': Array<AdminUserChallenge>;
    /**
     * 
     * @type {Array<AdminUserAssignment>}
     * @memberof AdminUserDetailsResponse
     */
    'assignments': Array<AdminUserAssignment>;
}
/**
 * Feedback data for the assignment submission
 * @export
 * @interface AssignmentFeedbackData
 */
export interface AssignmentFeedbackData {
    /**
     * Grade for the organization-focused evaluation (1-10 scale)
     * @type {number}
     * @memberof AssignmentFeedbackData
     */
    'org_grade'?: number | null;
    /**
     * Detailed feedback for the organization in markdown format
     * @type {string}
     * @memberof AssignmentFeedbackData
     */
    'org_feedback_md'?: string | null;
    /**
     * Numerical grade for the user submission (1-10 scale)
     * @type {number}
     * @memberof AssignmentFeedbackData
     */
    'user_grade': number;
    /**
     * Detailed feedback for the user in markdown format
     * @type {string}
     * @memberof AssignmentFeedbackData
     */
    'user_body': string;
}
/**
 * 
 * @export
 * @interface AuthResponse
 */
export interface AuthResponse {
    /**
     * 
     * @type {User}
     * @memberof AuthResponse
     */
    'user': User;
    /**
     * 
     * @type {Person}
     * @memberof AuthResponse
     */
    'person'?: Person;
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    'accessToken': string;
    /**
     * 
     * @type {number}
     * @memberof AuthResponse
     */
    'expiresIn': number;
    /**
     * 
     * @type {OrganizationType}
     * @memberof AuthResponse
     */
    'organizationType'?: OrganizationType;
}


/**
 * Result of a single bulk invite attempt
 * @export
 * @interface BulkInviteResult
 */
export interface BulkInviteResult {
    /**
     * The waiting list entry ID
     * @type {string}
     * @memberof BulkInviteResult
     */
    'waitingListId': string;
    /**
     * Email address of the invitee
     * @type {string}
     * @memberof BulkInviteResult
     */
    'email'?: string;
    /**
     * Whether the invitation was successfully sent
     * @type {boolean}
     * @memberof BulkInviteResult
     */
    'success': boolean;
    /**
     * ID of the created invitation (if successful)
     * @type {string}
     * @memberof BulkInviteResult
     */
    'invitationId'?: string;
    /**
     * Error message (if failed)
     * @type {string}
     * @memberof BulkInviteResult
     */
    'error'?: string;
}
/**
 * Request to bulk invite users from the waiting list
 * @export
 * @interface BulkInviteWaitingListRequest
 */
export interface BulkInviteWaitingListRequest {
    /**
     * Array of waiting list entry IDs to invite
     * @type {Array<string>}
     * @memberof BulkInviteWaitingListRequest
     */
    'waitingListIds': Array<string>;
    /**
     * Access groups to assign to all invitations
     * @type {Array<string>}
     * @memberof BulkInviteWaitingListRequest
     */
    'accessGroups': Array<string>;
    /**
     * Validity period in days for all invitations
     * @type {number}
     * @memberof BulkInviteWaitingListRequest
     */
    'validFor'?: number;
    /**
     * Custom body for all invitation emails
     * @type {string}
     * @memberof BulkInviteWaitingListRequest
     */
    'customBody'?: string;
    /**
     * 
     * @type {UserRole}
     * @memberof BulkInviteWaitingListRequest
     */
    'role'?: UserRole;
    /**
     * ID of the user who is inviting
     * @type {string}
     * @memberof BulkInviteWaitingListRequest
     */
    'inviterId'?: string;
    /**
     * Name of the user who is inviting
     * @type {string}
     * @memberof BulkInviteWaitingListRequest
     */
    'inviterName'?: string;
}


/**
 * Response from bulk inviting waiting list users
 * @export
 * @interface BulkInviteWaitingListResponse
 */
export interface BulkInviteWaitingListResponse {
    /**
     * Total number of waiting list IDs requested
     * @type {number}
     * @memberof BulkInviteWaitingListResponse
     */
    'totalRequested': number;
    /**
     * Number of invitations successfully sent
     * @type {number}
     * @memberof BulkInviteWaitingListResponse
     */
    'successful': number;
    /**
     * Number of invitations that failed
     * @type {number}
     * @memberof BulkInviteWaitingListResponse
     */
    'failed': number;
    /**
     * Detailed results for each invitation attempt
     * @type {Array<BulkInviteResult>}
     * @memberof BulkInviteWaitingListResponse
     */
    'results': Array<BulkInviteResult>;
}
/**
 * 
 * @export
 * @interface CreateInvitationRequest
 */
export interface CreateInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'email': string;
    /**
     * First name of the invitee. If not provided, generic wording will be used in the invitation email.
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'firstName'?: string;
    /**
     * Last name of the invitee. If not provided, generic wording will be used in the invitation email.
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'lastName'?: string;
    /**
     * ID of the user who invited the user
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'inviterId'?: string;
    /**
     * Name of the user who invited the user
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'inviterName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateInvitationRequest
     */
    'accessGroups': Array<string>;
    /**
     * Validity period in days
     * @type {number}
     * @memberof CreateInvitationRequest
     */
    'validFor': number;
    /**
     * Custom body for the invitation
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'customBody'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'organizationId'?: string;
    /**
     * Whether to send emails to the invitee
     * @type {boolean}
     * @memberof CreateInvitationRequest
     */
    'sendEmails'?: boolean;
    /**
     * 
     * @type {UserRole}
     * @memberof CreateInvitationRequest
     */
    'role'?: UserRole;
}


/**
 * 
 * @export
 * @interface CreatePersonRequest
 */
export interface CreatePersonRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePersonRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonRequest
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonRequest
     */
    'organizationId': string;
}
/**
 * 
 * @export
 * @interface CreateReleaseNoteRequest
 */
export interface CreateReleaseNoteRequest {
    /**
     * URL-friendly unique identifier for deep linking (e.g. /updates/slug)
     * @type {string}
     * @memberof CreateReleaseNoteRequest
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReleaseNoteRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReleaseNoteRequest
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReleaseNoteRequest
     */
    'noteDate': string;
    /**
     * 
     * @type {Array<ReleaseNoteCategory>}
     * @memberof CreateReleaseNoteRequest
     */
    'labels': Array<ReleaseNoteCategory>;
    /**
     * When false, note is hidden from non-admin users
     * @type {boolean}
     * @memberof CreateReleaseNoteRequest
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface DeletePersonResponse
 */
export interface DeletePersonResponse {
    /**
     * 
     * @type {string}
     * @memberof DeletePersonResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'error': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorCode'?: ErrorResponseErrorCodeEnum;
}

export const ErrorResponseErrorCodeEnum = {
    UnverifiedEmail: 'unverifiedEmail',
    InvalidCredentials: 'invalidCredentials',
    UninvitedEmail: 'uninvitedEmail',
    UserNotFound: 'userNotFound',
    InvalidToken: 'invalidToken',
    ExpiredToken: 'expiredToken',
    BadRequest: 'badRequest',
    AcceptedToken: 'acceptedToken',
    AlreadyJoinedPublicAssignment: 'alreadyJoinedPublicAssignment',
    UserAlreadyExists: 'userAlreadyExists'
} as const;

export type ErrorResponseErrorCodeEnum = typeof ErrorResponseErrorCodeEnum[keyof typeof ErrorResponseErrorCodeEnum];

/**
 * 
 * @export
 * @interface ForgotPasswordRequest
 */
export interface ForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface GetQueryFiltersParameter
 */
export interface GetQueryFiltersParameter {
    /**
     * 
     * @type {UserRole}
     * @memberof GetQueryFiltersParameter
     */
    'role'?: UserRole;
    /**
     * Filter by active status
     * @type {boolean}
     * @memberof GetQueryFiltersParameter
     */
    'isActive'?: boolean;
    /**
     * Filter by verification status
     * @type {boolean}
     * @memberof GetQueryFiltersParameter
     */
    'isVerified'?: boolean;
}


/**
 * Source where the user heard about us
 * @export
 * @enum {string}
 */

export const HeardOfUsSource = {
    Instagram: 'instagram',
    Facebook: 'facebook',
    Linkedin: 'linkedin',
    Reddit: 'reddit',
    X: 'x',
    ChatGpt: 'chatGPT',
    Gemini: 'gemini',
    Claude: 'claude',
    Google: 'google',
    Bing: 'bing',
    Yandex: 'yandex',
    Email: 'email',
    WordOfMouth: 'wordOfMouth',
    Other: 'other'
} as const;

export type HeardOfUsSource = typeof HeardOfUsSource[keyof typeof HeardOfUsSource];


/**
 * 
 * @export
 * @interface Invitation
 */
export interface Invitation {
    /**
     * 
     * @type {string}
     * @memberof Invitation
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Invitation
     */
    'email': string;
    /**
     * First name of the invitee. May be empty for bulk invitations from waiting list.
     * @type {string}
     * @memberof Invitation
     */
    'firstName'?: string;
    /**
     * Last name of the invitee. May be empty for bulk invitations from waiting list.
     * @type {string}
     * @memberof Invitation
     */
    'lastName'?: string;
    /**
     * Name of the user who invited the user
     * @type {string}
     * @memberof Invitation
     */
    'inviterName'?: string;
    /**
     * ID of the user who invited the user
     * @type {string}
     * @memberof Invitation
     */
    'inviterId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Invitation
     */
    'accessGroups': Array<string>;
    /**
     * Validity period in days
     * @type {number}
     * @memberof Invitation
     */
    'validFor': number;
    /**
     * ID of the user who registered using this invitation
     * @type {string}
     * @memberof Invitation
     */
    'registeredUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Invitation
     */
    'status': InvitationStatusEnum;
    /**
     * 
     * @type {UserRole}
     * @memberof Invitation
     */
    'role'?: UserRole;
    /**
     * 
     * @type {string}
     * @memberof Invitation
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Invitation
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Invitation
     */
    'expiresAt': string;
    /**
     * Custom body for the invitation
     * @type {string}
     * @memberof Invitation
     */
    'customBody'?: string;
    /**
     * 
     * @type {string}
     * @memberof Invitation
     */
    'organizationId'?: string;
    /**
     * SHA-256 hash of the invitation token for secure storage and efficient querying
     * @type {string}
     * @memberof Invitation
     */
    'tokenHash': string;
    /**
     * Invitation token (only present when sendEmails is false)
     * @type {string}
     * @memberof Invitation
     */
    'token'?: string;
}

export const InvitationStatusEnum = {
    Active: 'active',
    Accepted: 'accepted',
    Expired: 'expired',
    Revoked: 'revoked'
} as const;

export type InvitationStatusEnum = typeof InvitationStatusEnum[keyof typeof InvitationStatusEnum];

/**
 * 
 * @export
 * @interface InvitationDetails
 */
export interface InvitationDetails {
    /**
     * 
     * @type {string}
     * @memberof InvitationDetails
     */
    'email'?: string;
    /**
     * First name of the invitee. May be empty for bulk invitations from waiting list.
     * @type {string}
     * @memberof InvitationDetails
     */
    'firstName'?: string;
    /**
     * Last name of the invitee. May be empty for bulk invitations from waiting list.
     * @type {string}
     * @memberof InvitationDetails
     */
    'lastName'?: string;
    /**
     * Name of the user who invited the user
     * @type {string}
     * @memberof InvitationDetails
     */
    'inviterName'?: string;
    /**
     * 
     * @type {UserRole}
     * @memberof InvitationDetails
     */
    'role'?: UserRole;
    /**
     * Whether this is a public assignment link (no specific invitee)
     * @type {boolean}
     * @memberof InvitationDetails
     */
    'isPublicAssignment'?: boolean;
    /**
     * ID of the inviting organization, when the invitation is tied to one
     * @type {string}
     * @memberof InvitationDetails
     */
    'organizationId'?: string;
    /**
     * Organization name for public assignment links
     * @type {string}
     * @memberof InvitationDetails
     */
    'organizationName'?: string;
    /**
     * Square logo of the inviting organization, used by the invite hero. Optional.
     * @type {string}
     * @memberof InvitationDetails
     */
    'organizationLogoSquareURL'?: string;
    /**
     * Wide wordmark logo of the inviting organization. Optional.
     * @type {string}
     * @memberof InvitationDetails
     */
    'organizationLogoURL'?: string;
    /**
     * 
     * @type {OrganizationLogoCanvas}
     * @memberof InvitationDetails
     */
    'organizationLogoCanvas'?: OrganizationLogoCanvas;
    /**
     * Task name for public assignment links
     * @type {string}
     * @memberof InvitationDetails
     */
    'taskName'?: string;
    /**
     * True when an account already exists for the invitation\'s email. Only set for invitations with a known recipient email (referral, admin, partner).
     * @type {boolean}
     * @memberof InvitationDetails
     */
    'recipientHasAccount'?: boolean;
    /**
     * Optional personal message from the inviter (plain text — entities decoded from the stored HTML-escaped form).
     * @type {string}
     * @memberof InvitationDetails
     */
    'message'?: string;
}


/**
 * 
 * @export
 * @interface InvitationLink
 */
export interface InvitationLink {
    /**
     * ID of the person this invitation is for
     * @type {string}
     * @memberof InvitationLink
     */
    'personId': string;
    /**
     * Email address of the person
     * @type {string}
     * @memberof InvitationLink
     */
    'email': string;
    /**
     * ID of the created invitation
     * @type {string}
     * @memberof InvitationLink
     */
    'invitationId': string;
    /**
     * Invitation token (only returned when sendEmails is false)
     * @type {string}
     * @memberof InvitationLink
     */
    'token'?: string;
    /**
     * Full invitation link URL (only returned when sendEmails is false)
     * @type {string}
     * @memberof InvitationLink
     */
    'link'?: string;
}
/**
 * Sortable fields for invitations
 * @export
 * @enum {string}
 */

export const InvitationSortFieldEnum = {
    Id: 'id',
    Email: 'email',
    FirstName: 'firstName',
    LastName: 'lastName',
    Status: 'status',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    ExpiresAt: 'expiresAt',
    OrganizationId: 'organizationId',
    Role: 'role'
} as const;

export type InvitationSortFieldEnum = typeof InvitationSortFieldEnum[keyof typeof InvitationSortFieldEnum];


/**
 * 
 * @export
 * @interface InvitationsGetQueryFiltersParameter
 */
export interface InvitationsGetQueryFiltersParameter {
    /**
     * Filter by invitation status
     * @type {string}
     * @memberof InvitationsGetQueryFiltersParameter
     */
    'status'?: InvitationsGetQueryFiltersParameterStatusEnum;
    /**
     * Filter by organization ID
     * @type {string}
     * @memberof InvitationsGetQueryFiltersParameter
     */
    'organizationId'?: string;
}

export const InvitationsGetQueryFiltersParameterStatusEnum = {
    Active: 'active',
    Accepted: 'accepted',
    Expired: 'expired',
    Revoked: 'revoked'
} as const;

export type InvitationsGetQueryFiltersParameterStatusEnum = typeof InvitationsGetQueryFiltersParameterStatusEnum[keyof typeof InvitationsGetQueryFiltersParameterStatusEnum];

/**
 * Request to join a public assignment as an existing user
 * @export
 * @interface JoinPublicAssignmentRequest
 */
export interface JoinPublicAssignmentRequest {
    /**
     * Public assignment link token
     * @type {string}
     * @memberof JoinPublicAssignmentRequest
     */
    'assignmentToken': string;
}
/**
 * Response after successfully joining a public assignment
 * @export
 * @interface JoinPublicAssignmentResponse
 */
export interface JoinPublicAssignmentResponse {
    /**
     * 
     * @type {boolean}
     * @memberof JoinPublicAssignmentResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof JoinPublicAssignmentResponse
     */
    'message'?: string;
    /**
     * ID of the person record (existing or newly created)
     * @type {string}
     * @memberof JoinPublicAssignmentResponse
     */
    'personId': string;
    /**
     * ID of the assignment joined
     * @type {string}
     * @memberof JoinPublicAssignmentResponse
     */
    'assignmentId': string;
}
/**
 * Request body for listing users with filter, sort and pagination
 * @export
 * @interface ListUsersRequest
 */
export interface ListUsersRequest {
    /**
     * 
     * @type {UserListFilter}
     * @memberof ListUsersRequest
     */
    'filter'?: UserListFilter;
    /**
     * 
     * @type {UserSortFieldEnum}
     * @memberof ListUsersRequest
     */
    'sortField'?: UserSortFieldEnum;
    /**
     * 
     * @type {SortDirectionEnum}
     * @memberof ListUsersRequest
     */
    'sortDirection'?: SortDirectionEnum;
    /**
     * Maximum number of users to return
     * @type {number}
     * @memberof ListUsersRequest
     */
    'limit'?: number;
    /**
     * Number of users to skip before collecting the result set
     * @type {number}
     * @memberof ListUsersRequest
     */
    'offset'?: number;
}


/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRequest
     */
    'rememberMe'?: boolean;
}
/**
 * 
 * @export
 * @interface MyInvitation
 */
export interface MyInvitation {
    /**
     * 
     * @type {string}
     * @memberof MyInvitation
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MyInvitation
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MyInvitation
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof MyInvitation
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof MyInvitation
     */
    'status': MyInvitationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MyInvitation
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof MyInvitation
     */
    'expiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof MyInvitation
     */
    'acceptedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MyInvitation
     */
    'registeredUserId'?: string | null;
    /**
     * Signup URL with the invitation token. Only present for pending invitations.
     * @type {string}
     * @memberof MyInvitation
     */
    'inviteUrl'?: string;
}

export const MyInvitationStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Expired: 'expired'
} as const;

export type MyInvitationStatusEnum = typeof MyInvitationStatusEnum[keyof typeof MyInvitationStatusEnum];

/**
 * Background treatment for the organization\'s wordmark logo. Mirrors PartnerService.OrganizationLogoCanvas. plaque = light off-white surface, obsidian = dark surface, vellum = theme-adaptive frosted surface.
 * @export
 * @enum {string}
 */

export const OrganizationLogoCanvas = {
    Plaque: 'plaque',
    Obsidian: 'obsidian',
    Vellum: 'vellum'
} as const;

export type OrganizationLogoCanvas = typeof OrganizationLogoCanvas[keyof typeof OrganizationLogoCanvas];


/**
 * 
 * @export
 * @enum {string}
 */

export const OrganizationType = {
    Company: 'company',
    School: 'school'
} as const;

export type OrganizationType = typeof OrganizationType[keyof typeof OrganizationType];


/**
 * 
 * @export
 * @interface Person
 */
export interface Person {
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'userId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Person
     */
    'invitationIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'invitationToken'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Person
     */
    'managingOrganizationIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Person
     */
    'ongoingAssignments'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'onboardingStatus': PersonOnboardingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'updatedAt': string;
}

export const PersonOnboardingStatusEnum = {
    Added: 'added',
    Invited: 'invited',
    Joined: 'joined'
} as const;

export type PersonOnboardingStatusEnum = typeof PersonOnboardingStatusEnum[keyof typeof PersonOnboardingStatusEnum];

/**
 * 
 * @export
 * @interface PersonalInfo
 */
export interface PersonalInfo {
    /**
     * 
     * @type {string}
     * @memberof PersonalInfo
     */
    'country'?: string;
    /**
     * 
     * @type {number}
     * @memberof PersonalInfo
     */
    'yearsOfXP'?: number;
    /**
     * 
     * @type {Profession}
     * @memberof PersonalInfo
     */
    'profession'?: Profession;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const Profession = {
    DataScientist: 'data-scientist',
    DataAnalyst: 'data-analyst',
    DataEngineer: 'data-engineer',
    DataOperations: 'data-operations',
    MachineLearningEngineer: 'machine-learning-engineer',
    SoftwareEngineer: 'software-engineer',
    RecruitmentManager: 'recruitment-manager',
    Other: 'other'
} as const;

export type Profession = typeof Profession[keyof typeof Profession];


/**
 * 
 * @export
 * @interface ReferInvitationRequest
 */
export interface ReferInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof ReferInvitationRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ReferInvitationRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof ReferInvitationRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof ReferInvitationRequest
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferInvitationRequest
     */
    'sendEmail'?: boolean;
}
/**
 * 
 * @export
 * @interface ReferInvitationResponse
 */
export interface ReferInvitationResponse {
    /**
     * 
     * @type {Invitation}
     * @memberof ReferInvitationResponse
     */
    'invitation': Invitation;
    /**
     * 
     * @type {boolean}
     * @memberof ReferInvitationResponse
     */
    'wasExisting': boolean;
    /**
     * 
     * @type {string}
     * @memberof ReferInvitationResponse
     */
    'inviteUrl'?: string;
}
/**
 * 
 * @export
 * @interface RegisterRequest
 */
export interface RegisterRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequest
     */
    'confirmPassword': string;
    /**
     * 
     * @type {UserSource}
     * @memberof RegisterRequest
     */
    'source'?: UserSource;
    /**
     * Public assignment link token used for registration
     * @type {string}
     * @memberof RegisterRequest
     */
    'assignmentToken'?: string;
}


/**
 * 
 * @export
 * @interface RegisterResponse
 */
export interface RegisterResponse {
    /**
     * 
     * @type {string}
     * @memberof RegisterResponse
     */
    'result': RegisterResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponse
     */
    'email': string;
    /**
     * 
     * @type {AuthResponse}
     * @memberof RegisterResponse
     */
    'authResponse'?: AuthResponse;
}

export const RegisterResponseResultEnum = {
    Completed: 'completed',
    VerificationRequired: 'verificationRequired'
} as const;

export type RegisterResponseResultEnum = typeof RegisterResponseResultEnum[keyof typeof RegisterResponseResultEnum];

/**
 * 
 * @export
 * @interface ReleaseNote
 */
export interface ReleaseNote {
    /**
     * 
     * @type {string}
     * @memberof ReleaseNote
     */
    'id': string;
    /**
     * URL-friendly unique identifier for deep linking (e.g. /updates/slug)
     * @type {string}
     * @memberof ReleaseNote
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNote
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNote
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNote
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNote
     */
    'noteDate': string;
    /**
     * 
     * @type {Array<ReleaseNoteCategory>}
     * @memberof ReleaseNote
     */
    'labels': Array<ReleaseNoteCategory>;
    /**
     * 
     * @type {boolean}
     * @memberof ReleaseNote
     */
    'unread'?: boolean;
    /**
     * When false, note is hidden from non-admin users
     * @type {boolean}
     * @memberof ReleaseNote
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReleaseNoteCategory = {
    Feature: 'feature',
    Bugfix: 'bugfix',
    Challenge: 'challenge',
    Partner: 'partner',
    Admin: 'admin',
    Announcement: 'announcement',
    Comingsoon: 'comingsoon',
    Ai: 'ai',
    Improvement: 'improvement'
} as const;

export type ReleaseNoteCategory = typeof ReleaseNoteCategory[keyof typeof ReleaseNoteCategory];


/**
 * 
 * @export
 * @interface ReleaseNotesResponse
 */
export interface ReleaseNotesResponse {
    /**
     * 
     * @type {Array<ReleaseNote>}
     * @memberof ReleaseNotesResponse
     */
    'notes': Array<ReleaseNote>;
    /**
     * 
     * @type {number}
     * @memberof ReleaseNotesResponse
     */
    'unreadCount': number;
}
/**
 * 
 * @export
 * @interface ResendVerificationRequest
 */
export interface ResendVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof ResendVerificationRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface SendAssignmentRequest
 */
export interface SendAssignmentRequest {
    /**
     * 
     * @type {string}
     * @memberof SendAssignmentRequest
     */
    'assignmentId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendAssignmentRequest
     */
    'personIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SendAssignmentRequest
     */
    'organizationId': string;
    /**
     * Name of the organization
     * @type {string}
     * @memberof SendAssignmentRequest
     */
    'organizationName': string;
    /**
     * Whether to send invitation emails. If false, invitation links will be returned in the response.
     * @type {boolean}
     * @memberof SendAssignmentRequest
     */
    'sendEmails': boolean;
}
/**
 * 
 * @export
 * @interface SendAssignmentResponse
 */
export interface SendAssignmentResponse {
    /**
     * 
     * @type {string}
     * @memberof SendAssignmentResponse
     */
    'message'?: string;
    /**
     * Invitation links returned when sendEmails is false
     * @type {Array<InvitationLink>}
     * @memberof SendAssignmentResponse
     */
    'invitationLinks'?: Array<InvitationLink>;
}
/**
 * Request payload for sending assignment submitted notification emails to organization partners
 * @export
 * @interface SendAssignmentSubmittedNotificationRequest
 */
export interface SendAssignmentSubmittedNotificationRequest {
    /**
     * First name of the person who submitted the assignment
     * @type {string}
     * @memberof SendAssignmentSubmittedNotificationRequest
     */
    'firstName': string;
    /**
     * Last name of the person who submitted the assignment
     * @type {string}
     * @memberof SendAssignmentSubmittedNotificationRequest
     */
    'lastName': string;
    /**
     * Email of the person who submitted the assignment
     * @type {string}
     * @memberof SendAssignmentSubmittedNotificationRequest
     */
    'email': string;
    /**
     * Start date of the assignment
     * @type {string}
     * @memberof SendAssignmentSubmittedNotificationRequest
     */
    'startDate': string;
    /**
     * End date of the assignment (submission date)
     * @type {string}
     * @memberof SendAssignmentSubmittedNotificationRequest
     */
    'endDate': string;
    /**
     * Work time spent on the assignment in minutes
     * @type {number}
     * @memberof SendAssignmentSubmittedNotificationRequest
     */
    'workTime': number;
    /**
     * Name of the task/challenge
     * @type {string}
     * @memberof SendAssignmentSubmittedNotificationRequest
     */
    'taskName': string;
    /**
     * ID of the organization to find partner users
     * @type {string}
     * @memberof SendAssignmentSubmittedNotificationRequest
     */
    'organizationId': string;
    /**
     * 
     * @type {AssignmentFeedbackData}
     * @memberof SendAssignmentSubmittedNotificationRequest
     */
    'feedback': AssignmentFeedbackData;
}
/**
 * 
 * @export
 * @interface SendAssignmentSubmittedNotificationResponse
 */
export interface SendAssignmentSubmittedNotificationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SendAssignmentSubmittedNotificationResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof SendAssignmentSubmittedNotificationResponse
     */
    'message'?: string;
    /**
     * Number of emails successfully sent
     * @type {number}
     * @memberof SendAssignmentSubmittedNotificationResponse
     */
    'emailsSent': number;
}
/**
 * 
 * @export
 * @interface SendEmailRequest
 */
export interface SendEmailRequest {
    /**
     * List of recipient email addresses
     * @type {Array<string>}
     * @memberof SendEmailRequest
     */
    'recipients': Array<string>;
    /**
     * Email subject line
     * @type {string}
     * @memberof SendEmailRequest
     */
    'subject': string;
    /**
     * Email body content (HTML supported)
     * @type {string}
     * @memberof SendEmailRequest
     */
    'body': string;
    /**
     * Secret hash for authorizing the email send
     * @type {string}
     * @memberof SendEmailRequest
     */
    'secretHash': string;
    /**
     * Optional CC recipients
     * @type {Array<string>}
     * @memberof SendEmailRequest
     */
    'cc'?: Array<string>;
    /**
     * Optional BCC recipients
     * @type {Array<string>}
     * @memberof SendEmailRequest
     */
    'bcc'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SendEmailResponse
 */
export interface SendEmailResponse {
    /**
     * Whether the email was sent successfully
     * @type {boolean}
     * @memberof SendEmailResponse
     */
    'success'?: boolean;
    /**
     * Identifier of the sent email message
     * @type {string}
     * @memberof SendEmailResponse
     */
    'messageId'?: string;
}
/**
 * Request payload for sending user feedback notification email
 * @export
 * @interface SendUserFeedbackNotificationRequest
 */
export interface SendUserFeedbackNotificationRequest {
    /**
     * Name of the task/challenge
     * @type {string}
     * @memberof SendUserFeedbackNotificationRequest
     */
    'taskName': string;
    /**
     * Full name of the user who submitted feedback
     * @type {string}
     * @memberof SendUserFeedbackNotificationRequest
     */
    'userName': string;
    /**
     * Email of the user who submitted feedback
     * @type {string}
     * @memberof SendUserFeedbackNotificationRequest
     */
    'userEmail': string;
    /**
     * AI-generated feedback text for the challenge
     * @type {string}
     * @memberof SendUserFeedbackNotificationRequest
     */
    'challengeFeedbackText'?: string;
    /**
     * AI-generated grade for the challenge
     * @type {number}
     * @memberof SendUserFeedbackNotificationRequest
     */
    'challengeFeedbackGrade'?: number;
    /**
     * 
     * @type {UserFeedbackData}
     * @memberof SendUserFeedbackNotificationRequest
     */
    'userFeedback': UserFeedbackData;
}
/**
 * 
 * @export
 * @interface SendUserFeedbackNotificationResponse
 */
export interface SendUserFeedbackNotificationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SendUserFeedbackNotificationResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof SendUserFeedbackNotificationResponse
     */
    'message'?: string;
}
/**
 * Sort direction
 * @export
 * @enum {string}
 */

export const SortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SortDirectionEnum = typeof SortDirectionEnum[keyof typeof SortDirectionEnum];


/**
 * 
 * @export
 * @interface UpdateInvitationRequest
 */
export interface UpdateInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateInvitationRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateInvitationRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateInvitationRequest
     */
    'accessGroups'?: Array<string>;
    /**
     * ID of the user who invited the user
     * @type {string}
     * @memberof UpdateInvitationRequest
     */
    'inviterId'?: string;
    /**
     * Name of the user who invited the user
     * @type {string}
     * @memberof UpdateInvitationRequest
     */
    'inviterName'?: string;
    /**
     * Validity period in days
     * @type {number}
     * @memberof UpdateInvitationRequest
     */
    'validFor'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateInvitationRequest
     */
    'status'?: UpdateInvitationRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateInvitationRequest
     */
    'organizationId'?: string;
    /**
     * 
     * @type {UserRole}
     * @memberof UpdateInvitationRequest
     */
    'role'?: UserRole;
}

export const UpdateInvitationRequestStatusEnum = {
    Active: 'active',
    Accepted: 'accepted',
    Expired: 'expired',
    Revoked: 'revoked'
} as const;

export type UpdateInvitationRequestStatusEnum = typeof UpdateInvitationRequestStatusEnum[keyof typeof UpdateInvitationRequestStatusEnum];

/**
 * 
 * @export
 * @interface UpdatePersonRequest
 */
export interface UpdatePersonRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    'userId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePersonRequest
     */
    'invitationIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePersonRequest
     */
    'managingOrganizationIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePersonRequest
     */
    'ongoingAssignments'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdatePersonalInfoRequest
 */
export interface UpdatePersonalInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonalInfoRequest
     */
    'country'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePersonalInfoRequest
     */
    'yearsOfXP'?: number;
    /**
     * 
     * @type {Profession}
     * @memberof UpdatePersonalInfoRequest
     */
    'profession'?: Profession;
}


/**
 * 
 * @export
 * @interface UpdateReleaseNoteRequest
 */
export interface UpdateReleaseNoteRequest {
    /**
     * URL-friendly unique identifier for deep linking
     * @type {string}
     * @memberof UpdateReleaseNoteRequest
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReleaseNoteRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReleaseNoteRequest
     */
    'body'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReleaseNoteRequest
     */
    'noteDate'?: string;
    /**
     * 
     * @type {Array<ReleaseNoteCategory>}
     * @memberof UpdateReleaseNoteRequest
     */
    'labels'?: Array<ReleaseNoteCategory>;
    /**
     * When false, note is hidden from non-admin users
     * @type {boolean}
     * @memberof UpdateReleaseNoteRequest
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {UserRole}
     * @memberof UpdateUserRequest
     */
    'role'?: UserRole;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserRequest
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserRequest
     */
    'isVerified'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserRequest
     */
    'accessGroups'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'notes'?: string;
    /**
     * 
     * @type {PersonalInfo}
     * @memberof UpdateUserRequest
     */
    'personalInfo'?: PersonalInfo;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'organizationId'?: string;
    /**
     * 
     * @type {UserSettings}
     * @memberof UpdateUserRequest
     */
    'settings'?: UserSettings;
    /**
     * 
     * @type {UserSource}
     * @memberof UpdateUserRequest
     */
    'source'?: UserSource;
    /**
     * 
     * @type {Array<UserBadge>}
     * @memberof UpdateUserRequest
     */
    'badges'?: Array<UserBadge>;
}


/**
 * 
 * @export
 * @interface UpdateUserSettingsRequest
 */
export interface UpdateUserSettingsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserSettingsRequest
     */
    'dismissedPersonalInfo'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserSettingsRequest
     */
    'allowsAnonymousExposure'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserSettingsRequest
     */
    'dismissedCandidateBetaOffer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserSettingsRequest
     */
    'dismissedRodeoWorkspaceVideo'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserSettingsRequest
     */
    'feedbackLanguage'?: UpdateUserSettingsRequestFeedbackLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserSettingsRequest
     */
    'releaseNotesLastReadDate'?: string;
}

export const UpdateUserSettingsRequestFeedbackLanguageEnum = {
    En: 'en',
    He: 'he',
    Es: 'es',
    Fr: 'fr',
    De: 'de'
} as const;

export type UpdateUserSettingsRequestFeedbackLanguageEnum = typeof UpdateUserSettingsRequestFeedbackLanguageEnum[keyof typeof UpdateUserSettingsRequestFeedbackLanguageEnum];

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'avatar'?: string;
    /**
     * 
     * @type {UserRole}
     * @memberof User
     */
    'role': UserRole;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isVerified': boolean;
    /**
     * True iff the system has proof the user owns this email address (clicked email-delivered link, completed verification, or signed up via OAuth). Distinct from isVerified, which is the operational access gate.
     * @type {boolean}
     * @memberof User
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    'accessGroups': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'invitationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastLoginAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'notes'?: string;
    /**
     * 
     * @type {PersonalInfo}
     * @memberof User
     */
    'personalInfo'?: PersonalInfo;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'organizationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'personId'?: string;
    /**
     * 
     * @type {UserSettings}
     * @memberof User
     */
    'settings'?: UserSettings;
    /**
     * 
     * @type {UserSource}
     * @memberof User
     */
    'source'?: UserSource;
    /**
     * 
     * @type {Array<UserBadge>}
     * @memberof User
     */
    'badges'?: Array<UserBadge>;
    /**
     * Authentication provider used by this user
     * @type {string}
     * @memberof User
     */
    'authProvider'?: UserAuthProviderEnum;
}

export const UserAuthProviderEnum = {
    Local: 'local',
    Google: 'google',
    Linkedin: 'linkedin'
} as const;

export type UserAuthProviderEnum = typeof UserAuthProviderEnum[keyof typeof UserAuthProviderEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const UserBadge = {
    AssignmentOnly: 'assignmentOnly',
    AlphaTester: 'alphaTester',
    HardcoreUser: 'hardcoreUser'
} as const;

export type UserBadge = typeof UserBadge[keyof typeof UserBadge];


/**
 * User\'s feedback on the AI-generated challenge feedback
 * @export
 * @interface UserFeedbackData
 */
export interface UserFeedbackData {
    /**
     * Overall rating of the feedback (1-6)
     * @type {number}
     * @memberof UserFeedbackData
     */
    'overallRating'?: number;
    /**
     * Would practice again rating (1-3)
     * @type {number}
     * @memberof UserFeedbackData
     */
    'practiceNextRating'?: number;
    /**
     * Whether user agrees with the AI feedback
     * @type {boolean}
     * @memberof UserFeedbackData
     */
    'agreeWithFeedback': boolean;
    /**
     * Reason for disagreement (if agreeWithFeedback is false)
     * @type {string}
     * @memberof UserFeedbackData
     */
    'whyNoAgree'?: string;
    /**
     * Additional comments from the user
     * @type {string}
     * @memberof UserFeedbackData
     */
    'freeText'?: string;
    /**
     * Timestamp when feedback was submitted
     * @type {number}
     * @memberof UserFeedbackData
     */
    'submissionDate'?: number;
}
/**
 * Filter criteria for listing users; array fields match if the user matches any value in the array
 * @export
 * @interface UserListFilter
 */
export interface UserListFilter {
    /**
     * Filter by user roles (match any)
     * @type {Array<UserRole>}
     * @memberof UserListFilter
     */
    'role'?: Array<UserRole>;
    /**
     * Filter by active status
     * @type {boolean}
     * @memberof UserListFilter
     */
    'isActive'?: boolean;
    /**
     * Filter by verification status
     * @type {boolean}
     * @memberof UserListFilter
     */
    'isVerified'?: boolean;
    /**
     * Filter by access groups (match any)
     * @type {Array<string>}
     * @memberof UserListFilter
     */
    'accessGroups'?: Array<string>;
    /**
     * Filter by organization IDs (match any)
     * @type {Array<string>}
     * @memberof UserListFilter
     */
    'organizationId'?: Array<string>;
    /**
     * Text search across email, first name, and last name
     * @type {string}
     * @memberof UserListFilter
     */
    'search'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UserRole = {
    Admin: 'admin',
    User: 'user',
    Partner: 'partner'
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];


/**
 * 
 * @export
 * @interface UserSearchResult
 */
export interface UserSearchResult {
    /**
     * 
     * @type {string}
     * @memberof UserSearchResult
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserSearchResult
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserSearchResult
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserSearchResult
     */
    'lastName': string;
}
/**
 * 
 * @export
 * @interface UserSettings
 */
export interface UserSettings {
    /**
     * 
     * @type {boolean}
     * @memberof UserSettings
     */
    'dismissedPersonalInfo'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettings
     */
    'allowsAnonymousExposure'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettings
     */
    'dismissedCandidateBetaOffer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSettings
     */
    'dismissedRodeoWorkspaceVideo'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSettings
     */
    'feedbackLanguage'?: UserSettingsFeedbackLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof UserSettings
     */
    'releaseNotesLastReadDate'?: string;
}

export const UserSettingsFeedbackLanguageEnum = {
    En: 'en',
    He: 'he',
    Es: 'es',
    Fr: 'fr',
    De: 'de'
} as const;

export type UserSettingsFeedbackLanguageEnum = typeof UserSettingsFeedbackLanguageEnum[keyof typeof UserSettingsFeedbackLanguageEnum];

/**
 * Sortable fields for users
 * @export
 * @enum {string}
 */

export const UserSortFieldEnum = {
    Id: 'id',
    Email: 'email',
    FirstName: 'firstName',
    LastName: 'lastName',
    Role: 'role',
    IsActive: 'isActive',
    IsVerified: 'isVerified',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    LastLoginAt: 'lastLoginAt',
    OrganizationId: 'organizationId'
} as const;

export type UserSortFieldEnum = typeof UserSortFieldEnum[keyof typeof UserSortFieldEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const UserSource = {
    Organic: 'organic',
    Invited: 'invited',
    PartnerCandidate: 'partnerCandidate',
    PartnerStudent: 'partnerStudent',
    PublicCandidate: 'publicCandidate',
    PublicStudent: 'publicStudent'
} as const;

export type UserSource = typeof UserSource[keyof typeof UserSource];


/**
 * 
 * @export
 * @interface UserVoiceImage
 */
export interface UserVoiceImage {
    /**
     * Base64-encoded image bytes, no data-URL prefix
     * @type {string}
     * @memberof UserVoiceImage
     */
    'data': string;
    /**
     * 
     * @type {string}
     * @memberof UserVoiceImage
     */
    'mimeType': UserVoiceImageMimeTypeEnum;
}

export const UserVoiceImageMimeTypeEnum = {
    ImagePng: 'image/png',
    ImageJpeg: 'image/jpeg',
    ImageWebp: 'image/webp'
} as const;

export type UserVoiceImageMimeTypeEnum = typeof UserVoiceImageMimeTypeEnum[keyof typeof UserVoiceImageMimeTypeEnum];

/**
 * 
 * @export
 * @interface UserVoiceRequest
 */
export interface UserVoiceRequest {
    /**
     * 
     * @type {string}
     * @memberof UserVoiceRequest
     */
    'topic': UserVoiceRequestTopicEnum;
    /**
     * 
     * @type {string}
     * @memberof UserVoiceRequest
     */
    'message': string;
    /**
     * 
     * @type {UserVoiceImage}
     * @memberof UserVoiceRequest
     */
    'image'?: UserVoiceImage;
}

export const UserVoiceRequestTopicEnum = {
    General: 'general',
    Workspace: 'workspace',
    Challenges: 'challenges',
    Bug: 'bug',
    Feature: 'feature'
} as const;

export type UserVoiceRequestTopicEnum = typeof UserVoiceRequestTopicEnum[keyof typeof UserVoiceRequestTopicEnum];

/**
 * 
 * @export
 * @interface UserVoiceResponse
 */
export interface UserVoiceResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserVoiceResponse
     */
    'ok': boolean;
}
/**
 * 
 * @export
 * @interface VerifyEmailRequest
 */
export interface VerifyEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyEmailRequest
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface WaitingListEntry
 */
export interface WaitingListEntry {
    /**
     * Unique identifier for the waiting list entry
     * @type {string}
     * @memberof WaitingListEntry
     */
    'id': string;
    /**
     * Email address of the person on the waiting list
     * @type {string}
     * @memberof WaitingListEntry
     */
    'email': string;
    /**
     * First name (optional)
     * @type {string}
     * @memberof WaitingListEntry
     */
    'firstName'?: string;
    /**
     * Last name (optional)
     * @type {string}
     * @memberof WaitingListEntry
     */
    'lastName'?: string;
    /**
     * 
     * @type {HeardOfUsSource}
     * @memberof WaitingListEntry
     */
    'heardOfUs'?: HeardOfUsSource;
    /**
     * Additional details when heardOfUs is \'other\'
     * @type {string}
     * @memberof WaitingListEntry
     */
    'heardOfUsOther'?: string;
    /**
     * IP address of the person who joined the waiting list
     * @type {string}
     * @memberof WaitingListEntry
     */
    'ipAddress'?: string;
    /**
     * When the entry was created
     * @type {string}
     * @memberof WaitingListEntry
     */
    'createdAt': string;
    /**
     * When the entry was last updated
     * @type {string}
     * @memberof WaitingListEntry
     */
    'updatedAt': string;
    /**
     * Whether there is an invitation with the same email
     * @type {boolean}
     * @memberof WaitingListEntry
     */
    'hasInvitation': boolean;
}


/**
 * 
 * @export
 * @interface WaitingListGetResponse
 */
export interface WaitingListGetResponse {
    /**
     * Array of waiting list entries
     * @type {Array<WaitingListEntry>}
     * @memberof WaitingListGetResponse
     */
    'subscriptions': Array<WaitingListEntry>;
}
/**
 * 
 * @export
 * @interface WaitingListRequest
 */
export interface WaitingListRequest {
    /**
     * Email address of the person joining the waiting list
     * @type {string}
     * @memberof WaitingListRequest
     */
    'email': string;
    /**
     * First name (optional)
     * @type {string}
     * @memberof WaitingListRequest
     */
    'firstName'?: string;
    /**
     * Last name (optional)
     * @type {string}
     * @memberof WaitingListRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {HeardOfUsSource}
     * @memberof WaitingListRequest
     */
    'heardOfUs'?: HeardOfUsSource;
    /**
     * Additional details when heardOfUs is \'other\'
     * @type {string}
     * @memberof WaitingListRequest
     */
    'heardOfUsOther'?: string;
    /**
     * Optional waiting list ID for updating existing entry
     * @type {string}
     * @memberof WaitingListRequest
     */
    'waitingListId'?: string;
}


/**
 * 
 * @export
 * @interface WaitingListResponse
 */
export interface WaitingListResponse {
    /**
     * Unique identifier for the waiting list entry
     * @type {string}
     * @memberof WaitingListResponse
     */
    'waitingListId': string;
}
/**
 * Sortable fields for waiting list entries
 * @export
 * @enum {string}
 */

export const WaitingListSortFieldEnum = {
    Id: 'id',
    Email: 'email',
    FirstName: 'firstName',
    LastName: 'lastName',
    HeardOfUs: 'heardOfUs',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt'
} as const;

export type WaitingListSortFieldEnum = typeof WaitingListSortFieldEnum[keyof typeof WaitingListSortFieldEnum];



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin action: delete user and all related resources
         * @param {string} id 
         * @param {AdminDeleteUserRequest} adminDeleteUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminActionsDeleteUser: async (id: string, adminDeleteUserRequest: AdminDeleteUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminActionsDeleteUser', 'id', id)
            // verify required parameter 'adminDeleteUserRequest' is not null or undefined
            assertParamExists('adminActionsDeleteUser', 'adminDeleteUserRequest', adminDeleteUserRequest)
            const localVarPath = `/admin/actions/delete-user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminDeleteUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get admin dashboard statistics and activity logs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDashboardGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns aggregated data for admin statistics charts: user signups, challenges over time, and task overview.
         * @summary Get admin statistics data for charts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get admin user details with challenges and assignments
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserDetailsId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUserDetailsId', 'id', id)
            const localVarPath = `/admin/user-details/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request password reset
         * @param {ForgotPasswordRequest} forgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authForgotPasswordPost: async (forgotPasswordRequest: ForgotPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotPasswordRequest' is not null or undefined
            assertParamExists('authForgotPasswordPost', 'forgotPasswordRequest', forgotPasswordRequest)
            const localVarPath = `/auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Handle Google OAuth callback
         * @param {string} [code] Authorization code from Google
         * @param {string} [state] State parameter for CSRF protection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGoogleCallbackGet: async (code?: string, state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/google/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initiate Google OAuth authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGoogleGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login user
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginPost: async (loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('authLoginPost', 'loginRequest', loginRequest)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogoutPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh and trigger token rotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRefreshPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset password with token
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authResetPasswordPost: async (resetPasswordRequest: ResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequest' is not null or undefined
            assertParamExists('authResetPasswordPost', 'resetPasswordRequest', resetPasswordRequest)
            const localVarPath = `/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate access token for cross-service authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authValidateTokenPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/validate-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify user email with token
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authVerifyEmailPost: async (verifyEmailRequest: VerifyEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyEmailRequest' is not null or undefined
            assertParamExists('authVerifyEmailPost', 'verifyEmailRequest', verifyEmailRequest)
            const localVarPath = `/auth/verify-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a referral invitation
         * @param {ReferInvitationRequest} referInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReferral: async (referInvitationRequest: ReferInvitationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referInvitationRequest' is not null or undefined
            assertParamExists('createReferral', 'referInvitationRequest', referInvitationRequest)
            const localVarPath = `/invitations/refer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(referInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('idDelete', 'id', id)
            const localVarPath = `/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('idGet', 'id', id)
            const localVarPath = `/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a user by ID
         * @param {string} id 
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idPut: async (id: string, updateUserRequest: UpdateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('idPut', 'id', id)
            // verify required parameter 'updateUserRequest' is not null or undefined
            assertParamExists('idPut', 'updateUserRequest', updateUserRequest)
            const localVarPath = `/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Internal endpoint for sending email notifications to organization partners when a person submits an assignment solution and receives feedback. This endpoint should only be called by other backend services.
         * @summary Send assignment submitted notification email (internal use only)
         * @param {SendAssignmentSubmittedNotificationRequest} sendAssignmentSubmittedNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalSendAssignmentSubmittedNotificationPost: async (sendAssignmentSubmittedNotificationRequest: SendAssignmentSubmittedNotificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendAssignmentSubmittedNotificationRequest' is not null or undefined
            assertParamExists('internalSendAssignmentSubmittedNotificationPost', 'sendAssignmentSubmittedNotificationRequest', sendAssignmentSubmittedNotificationRequest)
            const localVarPath = `/internal/send-assignment-submitted-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendAssignmentSubmittedNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Internal endpoint for sending email notifications when users submit feedback on AI-generated challenge feedback. This endpoint should only be called by other backend services.
         * @summary Send user feedback notification email (internal use only)
         * @param {SendUserFeedbackNotificationRequest} sendUserFeedbackNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalSendUserFeedbackNotificationPost: async (sendUserFeedbackNotificationRequest: SendUserFeedbackNotificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendUserFeedbackNotificationRequest' is not null or undefined
            assertParamExists('internalSendUserFeedbackNotificationPost', 'sendUserFeedbackNotificationRequest', sendUserFeedbackNotificationRequest)
            const localVarPath = `/internal/send-user-feedback-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendUserFeedbackNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Claim an invitation as the logged-in user (e.g. user already had an account)
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationTokenClaimPost: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('invitationTokenClaimPost', 'token', token)
            const localVarPath = `/invitation/{token}/claim`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get invitation by token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationTokenGet: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('invitationTokenGet', 'token', token)
            const localVarPath = `/invitation/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update invitation
         * @param {string} token 
         * @param {UpdateInvitationRequest} updateInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationTokenPut: async (token: string, updateInvitationRequest: UpdateInvitationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('invitationTokenPut', 'token', token)
            // verify required parameter 'updateInvitationRequest' is not null or undefined
            assertParamExists('invitationTokenPut', 'updateInvitationRequest', updateInvitationRequest)
            const localVarPath = `/invitation/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all invitations with optional filtering, sorting and pagination
         * @summary List all invitations
         * @param {InvitationsGetQueryFiltersParameter} [queryFilters] Filters to apply when querying invitations
         * @param {InvitationSortFieldEnum} [sortField] Field to sort invitations by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for invitations
         * @param {number} [limit] Maximum number of invitations to return
         * @param {number} [offset] Number of invitations to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsGet: async (queryFilters?: InvitationsGetQueryFiltersParameter, sortField?: InvitationSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (queryFilters !== undefined) {
                for (const [key, value] of Object.entries(queryFilters)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send invitation
         * @param {CreateInvitationRequest} createInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsPost: async (createInvitationRequest: CreateInvitationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInvitationRequest' is not null or undefined
            assertParamExists('invitationsPost', 'createInvitationRequest', createInvitationRequest)
            const localVarPath = `/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Join Gamma access group (partner candidates only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinGammaPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/join-gamma`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows an existing authenticated user to join a public assignment. Creates a person record if one doesn\'t exist for the user.
         * @summary Join a public assignment (existing users only)
         * @param {JoinPublicAssignmentRequest} joinPublicAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinPublicAssignmentPost: async (joinPublicAssignmentRequest: JoinPublicAssignmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'joinPublicAssignmentRequest' is not null or undefined
            assertParamExists('joinPublicAssignmentPost', 'joinPublicAssignmentRequest', joinPublicAssignmentRequest)
            const localVarPath = `/join-public-assignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(joinPublicAssignmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List invitations sent by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyInvitations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invitations/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves users with a structured filter object plus pagination and sort. Admin only.
         * @summary List users with filters
         * @param {ListUsersRequest} listUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (listUsersRequest: ListUsersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listUsersRequest' is not null or undefined
            assertParamExists('listUsers', 'listUsersRequest', listUsersRequest)
            const localVarPath = `/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listUsersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send assignment to multiple persons (invite if not registered)
         * @param {SendAssignmentRequest} sendAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsAssignPost: async (sendAssignmentRequest: SendAssignmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendAssignmentRequest' is not null or undefined
            assertParamExists('personsAssignPost', 'sendAssignmentRequest', sendAssignmentRequest)
            const localVarPath = `/persons/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendAssignmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all persons
         * @param {Array<string>} [personIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsGet: async (personIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/persons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (personIds) {
                localVarQueryParameter['personIds'] = personIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a person by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('personsIdDelete', 'id', id)
            const localVarPath = `/persons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a person by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('personsIdGet', 'id', id)
            const localVarPath = `/persons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a person by ID
         * @param {string} id 
         * @param {UpdatePersonRequest} updatePersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsIdPut: async (id: string, updatePersonRequest: UpdatePersonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('personsIdPut', 'id', id)
            // verify required parameter 'updatePersonRequest' is not null or undefined
            assertParamExists('personsIdPut', 'updatePersonRequest', updatePersonRequest)
            const localVarPath = `/persons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePersonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new person
         * @param {CreatePersonRequest} createPersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsPost: async (createPersonRequest: CreatePersonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPersonRequest' is not null or undefined
            assertParamExists('personsPost', 'createPersonRequest', createPersonRequest)
            const localVarPath = `/persons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPersonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get release notes for current user
         * @param {boolean} [fullList] If true, return all notes; otherwise return last 5
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNotesGet: async (fullList?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/release-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fullList !== undefined) {
                localVarQueryParameter['fullList'] = fullList;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a release note (admin only, soft delete)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNotesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('releaseNotesIdDelete', 'id', id)
            const localVarPath = `/release-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a release note (admin only)
         * @param {string} id 
         * @param {UpdateReleaseNoteRequest} updateReleaseNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNotesIdPut: async (id: string, updateReleaseNoteRequest: UpdateReleaseNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('releaseNotesIdPut', 'id', id)
            // verify required parameter 'updateReleaseNoteRequest' is not null or undefined
            assertParamExists('releaseNotesIdPut', 'updateReleaseNoteRequest', updateReleaseNoteRequest)
            const localVarPath = `/release-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReleaseNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new release note (admin only)
         * @param {CreateReleaseNoteRequest} createReleaseNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNotesPost: async (createReleaseNoteRequest: CreateReleaseNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReleaseNoteRequest' is not null or undefined
            assertParamExists('releaseNotesPost', 'createReleaseNoteRequest', createReleaseNoteRequest)
            const localVarPath = `/release-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReleaseNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark release notes as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNotesReadPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/release-notes/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend email verification
         * @param {ResendVerificationRequest} resendVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationPost: async (resendVerificationRequest: ResendVerificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendVerificationRequest' is not null or undefined
            assertParamExists('resendVerificationPost', 'resendVerificationRequest', resendVerificationRequest)
            const localVarPath = `/resend-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all users with optional filtering, sorting and pagination
         * @summary List all users
         * @param {GetQueryFiltersParameter} [queryFilters] Filters to apply when querying users
         * @param {UserSortFieldEnum} [sortField] Field to sort users by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for users
         * @param {number} [limit] Maximum number of users to return
         * @param {number} [offset] Number of users to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootGet: async (queryFilters?: GetQueryFiltersParameter, sortField?: UserSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (queryFilters !== undefined) {
                for (const [key, value] of Object.entries(queryFilters)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register a new user
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootPost: async (registerRequest: RegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerRequest' is not null or undefined
            assertParamExists('rootPost', 'registerRequest', registerRequest)
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search users by name or email (admin only)
         * @param {string} q Search term matched against email, firstName, lastName
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGet: async (q: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchGet', 'q', q)
            const localVarPath = `/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends an email with the specified subject, body, and optional attachments. Requires a valid secret hash for authorization.
         * @summary Send an email to one or more recipients
         * @param {SendEmailRequest} sendEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailPost: async (sendEmailRequest: SendEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendEmailRequest' is not null or undefined
            assertParamExists('sendEmailPost', 'sendEmailRequest', sendEmailRequest)
            const localVarPath = `/send-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit app feedback (user voice)
         * @param {UserVoiceRequest} userVoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitUserVoice: async (userVoiceRequest: UserVoiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userVoiceRequest' is not null or undefined
            assertParamExists('submitUserVoice', 'userVoiceRequest', userVoiceRequest)
            const localVarPath = `/user-voice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userVoiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user personal info
         * @param {UpdatePersonalInfoRequest} updatePersonalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalInfoPut: async (updatePersonalInfoRequest: UpdatePersonalInfoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePersonalInfoRequest' is not null or undefined
            assertParamExists('updatePersonalInfoPut', 'updatePersonalInfoRequest', updatePersonalInfoRequest)
            const localVarPath = `/update-personal-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePersonalInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user settings
         * @param {UpdateUserSettingsRequest} updateUserSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSettingsPut: async (updateUserSettingsRequest: UpdateUserSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserSettingsRequest' is not null or undefined
            assertParamExists('updateUserSettingsPut', 'updateUserSettingsRequest', updateUserSettingsRequest)
            const localVarPath = `/update-user-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends invitations to multiple waiting list entries. Uses firstName/lastName from waiting list if available, otherwise sends invitation with generic wording.
         * @summary Bulk invite waiting list users
         * @param {BulkInviteWaitingListRequest} bulkInviteWaitingListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waitingListBulkInvitePost: async (bulkInviteWaitingListRequest: BulkInviteWaitingListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkInviteWaitingListRequest' is not null or undefined
            assertParamExists('waitingListBulkInvitePost', 'bulkInviteWaitingListRequest', bulkInviteWaitingListRequest)
            const localVarPath = `/waiting-list/bulk-invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkInviteWaitingListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all waiting list entries with optional sorting and pagination
         * @summary Get waiting list entries
         * @param {WaitingListSortFieldEnum} [sortField] Field to sort waiting list entries by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for waiting list entries
         * @param {number} [limit] Maximum number of waiting list entries to return
         * @param {number} [offset] Number of waiting list entries to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waitingListGet: async (sortField?: WaitingListSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/waiting-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Join waiting list
         * @param {WaitingListRequest} waitingListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waitingListPost: async (waitingListRequest: WaitingListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waitingListRequest' is not null or undefined
            assertParamExists('waitingListPost', 'waitingListRequest', waitingListRequest)
            const localVarPath = `/waiting-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waitingListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin action: delete user and all related resources
         * @param {string} id 
         * @param {AdminDeleteUserRequest} adminDeleteUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminActionsDeleteUser(id: string, adminDeleteUserRequest: AdminDeleteUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDeleteUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminActionsDeleteUser(id, adminDeleteUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminActionsDeleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get admin dashboard statistics and activity logs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDashboardGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDashboardGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns aggregated data for admin statistics charts: user signups, challenges over time, and task overview.
         * @summary Get admin statistics data for charts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminStatisticsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminStatisticsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminStatisticsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get admin user details with challenges and assignments
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUserDetailsId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUserDetailsId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminUserDetailsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request password reset
         * @param {ForgotPasswordRequest} forgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authForgotPasswordPost(forgotPasswordRequest: ForgotPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authForgotPasswordPost(forgotPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.authForgotPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Handle Google OAuth callback
         * @param {string} [code] Authorization code from Google
         * @param {string} [state] State parameter for CSRF protection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authGoogleCallbackGet(code?: string, state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authGoogleCallbackGet(code, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.authGoogleCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initiate Google OAuth authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authGoogleGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authGoogleGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.authGoogleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login user
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authLoginPost(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authLoginPost(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.authLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logout user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authLogoutPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authLogoutPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.authLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refresh and trigger token rotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authRefreshPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authRefreshPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.authRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset password with token
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authResetPasswordPost(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authResetPasswordPost(resetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.authResetPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate access token for cross-service authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authValidateTokenPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authValidateTokenPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.authValidateTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify user email with token
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authVerifyEmailPost(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authVerifyEmailPost(verifyEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.authVerifyEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a referral invitation
         * @param {ReferInvitationRequest} referInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReferral(referInvitationRequest: ReferInvitationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferInvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReferral(referInvitationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createReferral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async idDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.idDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.idDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async idGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.idGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.idGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a user by ID
         * @param {string} id 
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async idPut(id: string, updateUserRequest: UpdateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.idPut(id, updateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.idPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Internal endpoint for sending email notifications to organization partners when a person submits an assignment solution and receives feedback. This endpoint should only be called by other backend services.
         * @summary Send assignment submitted notification email (internal use only)
         * @param {SendAssignmentSubmittedNotificationRequest} sendAssignmentSubmittedNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalSendAssignmentSubmittedNotificationPost(sendAssignmentSubmittedNotificationRequest: SendAssignmentSubmittedNotificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendAssignmentSubmittedNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalSendAssignmentSubmittedNotificationPost(sendAssignmentSubmittedNotificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.internalSendAssignmentSubmittedNotificationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Internal endpoint for sending email notifications when users submit feedback on AI-generated challenge feedback. This endpoint should only be called by other backend services.
         * @summary Send user feedback notification email (internal use only)
         * @param {SendUserFeedbackNotificationRequest} sendUserFeedbackNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalSendUserFeedbackNotificationPost(sendUserFeedbackNotificationRequest: SendUserFeedbackNotificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendUserFeedbackNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalSendUserFeedbackNotificationPost(sendUserFeedbackNotificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.internalSendUserFeedbackNotificationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Claim an invitation as the logged-in user (e.g. user already had an account)
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationTokenClaimPost(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Invitation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationTokenClaimPost(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.invitationTokenClaimPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get invitation by token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationTokenGet(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationTokenGet(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.invitationTokenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update invitation
         * @param {string} token 
         * @param {UpdateInvitationRequest} updateInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationTokenPut(token: string, updateInvitationRequest: UpdateInvitationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Invitation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationTokenPut(token, updateInvitationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.invitationTokenPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all invitations with optional filtering, sorting and pagination
         * @summary List all invitations
         * @param {InvitationsGetQueryFiltersParameter} [queryFilters] Filters to apply when querying invitations
         * @param {InvitationSortFieldEnum} [sortField] Field to sort invitations by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for invitations
         * @param {number} [limit] Maximum number of invitations to return
         * @param {number} [offset] Number of invitations to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsGet(queryFilters?: InvitationsGetQueryFiltersParameter, sortField?: InvitationSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Invitation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsGet(queryFilters, sortField, sortDirection, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.invitationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send invitation
         * @param {CreateInvitationRequest} createInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsPost(createInvitationRequest: CreateInvitationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Invitation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsPost(createInvitationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.invitationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Join Gamma access group (partner candidates only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinGammaPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinGammaPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.joinGammaPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows an existing authenticated user to join a public assignment. Creates a person record if one doesn\'t exist for the user.
         * @summary Join a public assignment (existing users only)
         * @param {JoinPublicAssignmentRequest} joinPublicAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinPublicAssignmentPost(joinPublicAssignmentRequest: JoinPublicAssignmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JoinPublicAssignmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinPublicAssignmentPost(joinPublicAssignmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.joinPublicAssignmentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List invitations sent by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyInvitations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MyInvitation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyInvitations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listMyInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves users with a structured filter object plus pagination and sort. Admin only.
         * @summary List users with filters
         * @param {ListUsersRequest} listUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(listUsersRequest: ListUsersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(listUsersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send assignment to multiple persons (invite if not registered)
         * @param {SendAssignmentRequest} sendAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsAssignPost(sendAssignmentRequest: SendAssignmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendAssignmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personsAssignPost(sendAssignmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.personsAssignPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all persons
         * @param {Array<string>} [personIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsGet(personIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personsGet(personIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.personsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a person by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeletePersonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.personsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a person by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.personsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a person by ID
         * @param {string} id 
         * @param {UpdatePersonRequest} updatePersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsIdPut(id: string, updatePersonRequest: UpdatePersonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personsIdPut(id, updatePersonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.personsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new person
         * @param {CreatePersonRequest} createPersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personsPost(createPersonRequest: CreatePersonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personsPost(createPersonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.personsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get release notes for current user
         * @param {boolean} [fullList] If true, return all notes; otherwise return last 5
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseNotesGet(fullList?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseNotesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseNotesGet(fullList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.releaseNotesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a release note (admin only, soft delete)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseNotesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseNotesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.releaseNotesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a release note (admin only)
         * @param {string} id 
         * @param {UpdateReleaseNoteRequest} updateReleaseNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseNotesIdPut(id: string, updateReleaseNoteRequest: UpdateReleaseNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseNote>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseNotesIdPut(id, updateReleaseNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.releaseNotesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new release note (admin only)
         * @param {CreateReleaseNoteRequest} createReleaseNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseNotesPost(createReleaseNoteRequest: CreateReleaseNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseNote>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseNotesPost(createReleaseNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.releaseNotesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark release notes as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseNotesReadPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseNotesReadPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.releaseNotesReadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend email verification
         * @param {ResendVerificationRequest} resendVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendVerificationPost(resendVerificationRequest: ResendVerificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendVerificationPost(resendVerificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.resendVerificationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all users with optional filtering, sorting and pagination
         * @summary List all users
         * @param {GetQueryFiltersParameter} [queryFilters] Filters to apply when querying users
         * @param {UserSortFieldEnum} [sortField] Field to sort users by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for users
         * @param {number} [limit] Maximum number of users to return
         * @param {number} [offset] Number of users to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootGet(queryFilters?: GetQueryFiltersParameter, sortField?: UserSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootGet(queryFilters, sortField, sortDirection, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register a new user
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootPost(registerRequest: RegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootPost(registerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search users by name or email (admin only)
         * @param {string} q Search term matched against email, firstName, lastName
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchGet(q: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserSearchResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchGet(q, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends an email with the specified subject, body, and optional attachments. Requires a valid secret hash for authorization.
         * @summary Send an email to one or more recipients
         * @param {SendEmailRequest} sendEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailPost(sendEmailRequest: SendEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailPost(sendEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit app feedback (user voice)
         * @param {UserVoiceRequest} userVoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitUserVoice(userVoiceRequest: UserVoiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserVoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitUserVoice(userVoiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.submitUserVoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user personal info
         * @param {UpdatePersonalInfoRequest} updatePersonalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersonalInfoPut(updatePersonalInfoRequest: UpdatePersonalInfoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersonalInfoPut(updatePersonalInfoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updatePersonalInfoPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user settings
         * @param {UpdateUserSettingsRequest} updateUserSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserSettingsPut(updateUserSettingsRequest: UpdateUserSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserSettingsPut(updateUserSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateUserSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends invitations to multiple waiting list entries. Uses firstName/lastName from waiting list if available, otherwise sends invitation with generic wording.
         * @summary Bulk invite waiting list users
         * @param {BulkInviteWaitingListRequest} bulkInviteWaitingListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waitingListBulkInvitePost(bulkInviteWaitingListRequest: BulkInviteWaitingListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkInviteWaitingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waitingListBulkInvitePost(bulkInviteWaitingListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.waitingListBulkInvitePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all waiting list entries with optional sorting and pagination
         * @summary Get waiting list entries
         * @param {WaitingListSortFieldEnum} [sortField] Field to sort waiting list entries by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for waiting list entries
         * @param {number} [limit] Maximum number of waiting list entries to return
         * @param {number} [offset] Number of waiting list entries to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waitingListGet(sortField?: WaitingListSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingListGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waitingListGet(sortField, sortDirection, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.waitingListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Join waiting list
         * @param {WaitingListRequest} waitingListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waitingListPost(waitingListRequest: WaitingListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaitingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waitingListPost(waitingListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.waitingListPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin action: delete user and all related resources
         * @param {string} id 
         * @param {AdminDeleteUserRequest} adminDeleteUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminActionsDeleteUser(id: string, adminDeleteUserRequest: AdminDeleteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeleteUserResponse> {
            return localVarFp.adminActionsDeleteUser(id, adminDeleteUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get admin dashboard statistics and activity logs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDashboardGet(options?: RawAxiosRequestConfig): AxiosPromise<AdminDashboardResponse> {
            return localVarFp.adminDashboardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns aggregated data for admin statistics charts: user signups, challenges over time, and task overview.
         * @summary Get admin statistics data for charts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsGet(options?: RawAxiosRequestConfig): AxiosPromise<AdminStatisticsResponse> {
            return localVarFp.adminStatisticsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get admin user details with challenges and assignments
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserDetailsId(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserDetailsResponse> {
            return localVarFp.adminUserDetailsId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request password reset
         * @param {ForgotPasswordRequest} forgotPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authForgotPasswordPost(forgotPasswordRequest: ForgotPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authForgotPasswordPost(forgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Handle Google OAuth callback
         * @param {string} [code] Authorization code from Google
         * @param {string} [state] State parameter for CSRF protection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGoogleCallbackGet(code?: string, state?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authGoogleCallbackGet(code, state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initiate Google OAuth authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGoogleGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authGoogleGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login user
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLoginPost(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.authLoginPost(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogoutPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh and trigger token rotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRefreshPost(options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.authRefreshPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset password with token
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authResetPasswordPost(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authResetPasswordPost(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate access token for cross-service authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authValidateTokenPost(options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.authValidateTokenPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify user email with token
         * @param {VerifyEmailRequest} verifyEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authVerifyEmailPost(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.authVerifyEmailPost(verifyEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a referral invitation
         * @param {ReferInvitationRequest} referInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReferral(referInvitationRequest: ReferInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReferInvitationResponse> {
            return localVarFp.createReferral(referInvitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.idDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.idGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a user by ID
         * @param {string} id 
         * @param {UpdateUserRequest} updateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idPut(id: string, updateUserRequest: UpdateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.idPut(id, updateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Internal endpoint for sending email notifications to organization partners when a person submits an assignment solution and receives feedback. This endpoint should only be called by other backend services.
         * @summary Send assignment submitted notification email (internal use only)
         * @param {SendAssignmentSubmittedNotificationRequest} sendAssignmentSubmittedNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalSendAssignmentSubmittedNotificationPost(sendAssignmentSubmittedNotificationRequest: SendAssignmentSubmittedNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendAssignmentSubmittedNotificationResponse> {
            return localVarFp.internalSendAssignmentSubmittedNotificationPost(sendAssignmentSubmittedNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Internal endpoint for sending email notifications when users submit feedback on AI-generated challenge feedback. This endpoint should only be called by other backend services.
         * @summary Send user feedback notification email (internal use only)
         * @param {SendUserFeedbackNotificationRequest} sendUserFeedbackNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalSendUserFeedbackNotificationPost(sendUserFeedbackNotificationRequest: SendUserFeedbackNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendUserFeedbackNotificationResponse> {
            return localVarFp.internalSendUserFeedbackNotificationPost(sendUserFeedbackNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Claim an invitation as the logged-in user (e.g. user already had an account)
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationTokenClaimPost(token: string, options?: RawAxiosRequestConfig): AxiosPromise<Invitation> {
            return localVarFp.invitationTokenClaimPost(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get invitation by token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationTokenGet(token: string, options?: RawAxiosRequestConfig): AxiosPromise<InvitationDetails> {
            return localVarFp.invitationTokenGet(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update invitation
         * @param {string} token 
         * @param {UpdateInvitationRequest} updateInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationTokenPut(token: string, updateInvitationRequest: UpdateInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Invitation> {
            return localVarFp.invitationTokenPut(token, updateInvitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all invitations with optional filtering, sorting and pagination
         * @summary List all invitations
         * @param {InvitationsGetQueryFiltersParameter} [queryFilters] Filters to apply when querying invitations
         * @param {InvitationSortFieldEnum} [sortField] Field to sort invitations by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for invitations
         * @param {number} [limit] Maximum number of invitations to return
         * @param {number} [offset] Number of invitations to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsGet(queryFilters?: InvitationsGetQueryFiltersParameter, sortField?: InvitationSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Invitation>> {
            return localVarFp.invitationsGet(queryFilters, sortField, sortDirection, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send invitation
         * @param {CreateInvitationRequest} createInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsPost(createInvitationRequest: CreateInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Invitation> {
            return localVarFp.invitationsPost(createInvitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Join Gamma access group (partner candidates only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinGammaPost(options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.joinGammaPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Allows an existing authenticated user to join a public assignment. Creates a person record if one doesn\'t exist for the user.
         * @summary Join a public assignment (existing users only)
         * @param {JoinPublicAssignmentRequest} joinPublicAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinPublicAssignmentPost(joinPublicAssignmentRequest: JoinPublicAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<JoinPublicAssignmentResponse> {
            return localVarFp.joinPublicAssignmentPost(joinPublicAssignmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List invitations sent by the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyInvitations(options?: RawAxiosRequestConfig): AxiosPromise<Array<MyInvitation>> {
            return localVarFp.listMyInvitations(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves users with a structured filter object plus pagination and sort. Admin only.
         * @summary List users with filters
         * @param {ListUsersRequest} listUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(listUsersRequest: ListUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<User>> {
            return localVarFp.listUsers(listUsersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send assignment to multiple persons (invite if not registered)
         * @param {SendAssignmentRequest} sendAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsAssignPost(sendAssignmentRequest: SendAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendAssignmentResponse> {
            return localVarFp.personsAssignPost(sendAssignmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all persons
         * @param {Array<string>} [personIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsGet(personIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<Person>> {
            return localVarFp.personsGet(personIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a person by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DeletePersonResponse> {
            return localVarFp.personsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a person by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsIdGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Person> {
            return localVarFp.personsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a person by ID
         * @param {string} id 
         * @param {UpdatePersonRequest} updatePersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsIdPut(id: string, updatePersonRequest: UpdatePersonRequest, options?: RawAxiosRequestConfig): AxiosPromise<Person> {
            return localVarFp.personsIdPut(id, updatePersonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new person
         * @param {CreatePersonRequest} createPersonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personsPost(createPersonRequest: CreatePersonRequest, options?: RawAxiosRequestConfig): AxiosPromise<Person> {
            return localVarFp.personsPost(createPersonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get release notes for current user
         * @param {boolean} [fullList] If true, return all notes; otherwise return last 5
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNotesGet(fullList?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseNotesResponse> {
            return localVarFp.releaseNotesGet(fullList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a release note (admin only, soft delete)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNotesIdDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.releaseNotesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a release note (admin only)
         * @param {string} id 
         * @param {UpdateReleaseNoteRequest} updateReleaseNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNotesIdPut(id: string, updateReleaseNoteRequest: UpdateReleaseNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseNote> {
            return localVarFp.releaseNotesIdPut(id, updateReleaseNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new release note (admin only)
         * @param {CreateReleaseNoteRequest} createReleaseNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNotesPost(createReleaseNoteRequest: CreateReleaseNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReleaseNote> {
            return localVarFp.releaseNotesPost(createReleaseNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark release notes as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseNotesReadPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.releaseNotesReadPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend email verification
         * @param {ResendVerificationRequest} resendVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationPost(resendVerificationRequest: ResendVerificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendVerificationPost(resendVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all users with optional filtering, sorting and pagination
         * @summary List all users
         * @param {GetQueryFiltersParameter} [queryFilters] Filters to apply when querying users
         * @param {UserSortFieldEnum} [sortField] Field to sort users by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for users
         * @param {number} [limit] Maximum number of users to return
         * @param {number} [offset] Number of users to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootGet(queryFilters?: GetQueryFiltersParameter, sortField?: UserSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<User>> {
            return localVarFp.rootGet(queryFilters, sortField, sortDirection, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register a new user
         * @param {RegisterRequest} registerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootPost(registerRequest: RegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterResponse> {
            return localVarFp.rootPost(registerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search users by name or email (admin only)
         * @param {string} q Search term matched against email, firstName, lastName
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGet(q: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserSearchResult>> {
            return localVarFp.searchGet(q, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends an email with the specified subject, body, and optional attachments. Requires a valid secret hash for authorization.
         * @summary Send an email to one or more recipients
         * @param {SendEmailRequest} sendEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailPost(sendEmailRequest: SendEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendEmailResponse> {
            return localVarFp.sendEmailPost(sendEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit app feedback (user voice)
         * @param {UserVoiceRequest} userVoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitUserVoice(userVoiceRequest: UserVoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserVoiceResponse> {
            return localVarFp.submitUserVoice(userVoiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user personal info
         * @param {UpdatePersonalInfoRequest} updatePersonalInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalInfoPut(updatePersonalInfoRequest: UpdatePersonalInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.updatePersonalInfoPut(updatePersonalInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user settings
         * @param {UpdateUserSettingsRequest} updateUserSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSettingsPut(updateUserSettingsRequest: UpdateUserSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.updateUserSettingsPut(updateUserSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends invitations to multiple waiting list entries. Uses firstName/lastName from waiting list if available, otherwise sends invitation with generic wording.
         * @summary Bulk invite waiting list users
         * @param {BulkInviteWaitingListRequest} bulkInviteWaitingListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waitingListBulkInvitePost(bulkInviteWaitingListRequest: BulkInviteWaitingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkInviteWaitingListResponse> {
            return localVarFp.waitingListBulkInvitePost(bulkInviteWaitingListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all waiting list entries with optional sorting and pagination
         * @summary Get waiting list entries
         * @param {WaitingListSortFieldEnum} [sortField] Field to sort waiting list entries by
         * @param {SortDirectionEnum} [sortDirection] Sort direction for waiting list entries
         * @param {number} [limit] Maximum number of waiting list entries to return
         * @param {number} [offset] Number of waiting list entries to skip before starting to collect the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waitingListGet(sortField?: WaitingListSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListGetResponse> {
            return localVarFp.waitingListGet(sortField, sortDirection, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Join waiting list
         * @param {WaitingListRequest} waitingListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waitingListPost(waitingListRequest: WaitingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaitingListResponse> {
            return localVarFp.waitingListPost(waitingListRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Admin action: delete user and all related resources
     * @param {string} id 
     * @param {AdminDeleteUserRequest} adminDeleteUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminActionsDeleteUser(id: string, adminDeleteUserRequest: AdminDeleteUserRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminActionsDeleteUser(id, adminDeleteUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get admin dashboard statistics and activity logs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminDashboardGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns aggregated data for admin statistics charts: user signups, challenges over time, and task overview.
     * @summary Get admin statistics data for charts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminStatisticsGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminStatisticsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get admin user details with challenges and assignments
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminUserDetailsId(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminUserDetailsId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request password reset
     * @param {ForgotPasswordRequest} forgotPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authForgotPasswordPost(forgotPasswordRequest: ForgotPasswordRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authForgotPasswordPost(forgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Handle Google OAuth callback
     * @param {string} [code] Authorization code from Google
     * @param {string} [state] State parameter for CSRF protection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authGoogleCallbackGet(code?: string, state?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authGoogleCallbackGet(code, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initiate Google OAuth authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authGoogleGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authGoogleGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login user
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authLoginPost(loginRequest: LoginRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authLoginPost(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authLogoutPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh and trigger token rotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authRefreshPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authRefreshPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset password with token
     * @param {ResetPasswordRequest} resetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authResetPasswordPost(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authResetPasswordPost(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate access token for cross-service authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authValidateTokenPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authValidateTokenPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify user email with token
     * @param {VerifyEmailRequest} verifyEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authVerifyEmailPost(verifyEmailRequest: VerifyEmailRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authVerifyEmailPost(verifyEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a referral invitation
     * @param {ReferInvitationRequest} referInvitationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createReferral(referInvitationRequest: ReferInvitationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createReferral(referInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a user by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public idDelete(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).idDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a user by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public idGet(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).idGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a user by ID
     * @param {string} id 
     * @param {UpdateUserRequest} updateUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public idPut(id: string, updateUserRequest: UpdateUserRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).idPut(id, updateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Internal endpoint for sending email notifications to organization partners when a person submits an assignment solution and receives feedback. This endpoint should only be called by other backend services.
     * @summary Send assignment submitted notification email (internal use only)
     * @param {SendAssignmentSubmittedNotificationRequest} sendAssignmentSubmittedNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public internalSendAssignmentSubmittedNotificationPost(sendAssignmentSubmittedNotificationRequest: SendAssignmentSubmittedNotificationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).internalSendAssignmentSubmittedNotificationPost(sendAssignmentSubmittedNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Internal endpoint for sending email notifications when users submit feedback on AI-generated challenge feedback. This endpoint should only be called by other backend services.
     * @summary Send user feedback notification email (internal use only)
     * @param {SendUserFeedbackNotificationRequest} sendUserFeedbackNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public internalSendUserFeedbackNotificationPost(sendUserFeedbackNotificationRequest: SendUserFeedbackNotificationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).internalSendUserFeedbackNotificationPost(sendUserFeedbackNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Claim an invitation as the logged-in user (e.g. user already had an account)
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public invitationTokenClaimPost(token: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).invitationTokenClaimPost(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get invitation by token
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public invitationTokenGet(token: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).invitationTokenGet(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update invitation
     * @param {string} token 
     * @param {UpdateInvitationRequest} updateInvitationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public invitationTokenPut(token: string, updateInvitationRequest: UpdateInvitationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).invitationTokenPut(token, updateInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all invitations with optional filtering, sorting and pagination
     * @summary List all invitations
     * @param {InvitationsGetQueryFiltersParameter} [queryFilters] Filters to apply when querying invitations
     * @param {InvitationSortFieldEnum} [sortField] Field to sort invitations by
     * @param {SortDirectionEnum} [sortDirection] Sort direction for invitations
     * @param {number} [limit] Maximum number of invitations to return
     * @param {number} [offset] Number of invitations to skip before starting to collect the result set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public invitationsGet(queryFilters?: InvitationsGetQueryFiltersParameter, sortField?: InvitationSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).invitationsGet(queryFilters, sortField, sortDirection, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send invitation
     * @param {CreateInvitationRequest} createInvitationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public invitationsPost(createInvitationRequest: CreateInvitationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).invitationsPost(createInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Join Gamma access group (partner candidates only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public joinGammaPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).joinGammaPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows an existing authenticated user to join a public assignment. Creates a person record if one doesn\'t exist for the user.
     * @summary Join a public assignment (existing users only)
     * @param {JoinPublicAssignmentRequest} joinPublicAssignmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public joinPublicAssignmentPost(joinPublicAssignmentRequest: JoinPublicAssignmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).joinPublicAssignmentPost(joinPublicAssignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List invitations sent by the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listMyInvitations(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listMyInvitations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves users with a structured filter object plus pagination and sort. Admin only.
     * @summary List users with filters
     * @param {ListUsersRequest} listUsersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listUsers(listUsersRequest: ListUsersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listUsers(listUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send assignment to multiple persons (invite if not registered)
     * @param {SendAssignmentRequest} sendAssignmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public personsAssignPost(sendAssignmentRequest: SendAssignmentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).personsAssignPost(sendAssignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all persons
     * @param {Array<string>} [personIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public personsGet(personIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).personsGet(personIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a person by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public personsIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).personsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a person by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public personsIdGet(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).personsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a person by ID
     * @param {string} id 
     * @param {UpdatePersonRequest} updatePersonRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public personsIdPut(id: string, updatePersonRequest: UpdatePersonRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).personsIdPut(id, updatePersonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new person
     * @param {CreatePersonRequest} createPersonRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public personsPost(createPersonRequest: CreatePersonRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).personsPost(createPersonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get release notes for current user
     * @param {boolean} [fullList] If true, return all notes; otherwise return last 5
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public releaseNotesGet(fullList?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).releaseNotesGet(fullList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a release note (admin only, soft delete)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public releaseNotesIdDelete(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).releaseNotesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a release note (admin only)
     * @param {string} id 
     * @param {UpdateReleaseNoteRequest} updateReleaseNoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public releaseNotesIdPut(id: string, updateReleaseNoteRequest: UpdateReleaseNoteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).releaseNotesIdPut(id, updateReleaseNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new release note (admin only)
     * @param {CreateReleaseNoteRequest} createReleaseNoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public releaseNotesPost(createReleaseNoteRequest: CreateReleaseNoteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).releaseNotesPost(createReleaseNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark release notes as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public releaseNotesReadPost(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).releaseNotesReadPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend email verification
     * @param {ResendVerificationRequest} resendVerificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resendVerificationPost(resendVerificationRequest: ResendVerificationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resendVerificationPost(resendVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all users with optional filtering, sorting and pagination
     * @summary List all users
     * @param {GetQueryFiltersParameter} [queryFilters] Filters to apply when querying users
     * @param {UserSortFieldEnum} [sortField] Field to sort users by
     * @param {SortDirectionEnum} [sortDirection] Sort direction for users
     * @param {number} [limit] Maximum number of users to return
     * @param {number} [offset] Number of users to skip before starting to collect the result set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rootGet(queryFilters?: GetQueryFiltersParameter, sortField?: UserSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootGet(queryFilters, sortField, sortDirection, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register a new user
     * @param {RegisterRequest} registerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rootPost(registerRequest: RegisterRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootPost(registerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search users by name or email (admin only)
     * @param {string} q Search term matched against email, firstName, lastName
     * @param {number} [limit] Maximum number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchGet(q: string, limit?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchGet(q, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends an email with the specified subject, body, and optional attachments. Requires a valid secret hash for authorization.
     * @summary Send an email to one or more recipients
     * @param {SendEmailRequest} sendEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendEmailPost(sendEmailRequest: SendEmailRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendEmailPost(sendEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit app feedback (user voice)
     * @param {UserVoiceRequest} userVoiceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public submitUserVoice(userVoiceRequest: UserVoiceRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).submitUserVoice(userVoiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user personal info
     * @param {UpdatePersonalInfoRequest} updatePersonalInfoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePersonalInfoPut(updatePersonalInfoRequest: UpdatePersonalInfoRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePersonalInfoPut(updatePersonalInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user settings
     * @param {UpdateUserSettingsRequest} updateUserSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserSettingsPut(updateUserSettingsRequest: UpdateUserSettingsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserSettingsPut(updateUserSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends invitations to multiple waiting list entries. Uses firstName/lastName from waiting list if available, otherwise sends invitation with generic wording.
     * @summary Bulk invite waiting list users
     * @param {BulkInviteWaitingListRequest} bulkInviteWaitingListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public waitingListBulkInvitePost(bulkInviteWaitingListRequest: BulkInviteWaitingListRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).waitingListBulkInvitePost(bulkInviteWaitingListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all waiting list entries with optional sorting and pagination
     * @summary Get waiting list entries
     * @param {WaitingListSortFieldEnum} [sortField] Field to sort waiting list entries by
     * @param {SortDirectionEnum} [sortDirection] Sort direction for waiting list entries
     * @param {number} [limit] Maximum number of waiting list entries to return
     * @param {number} [offset] Number of waiting list entries to skip before starting to collect the result set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public waitingListGet(sortField?: WaitingListSortFieldEnum, sortDirection?: SortDirectionEnum, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).waitingListGet(sortField, sortDirection, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Join waiting list
     * @param {WaitingListRequest} waitingListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public waitingListPost(waitingListRequest: WaitingListRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).waitingListPost(waitingListRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



